export const DASHBOARD_HERO_HEIGHT = 272;
export const DASHBOARD_CARD_VALUE_BLOCK_HEIGHT = 132;
export const DASHBOARD_CARD_EVALUATION_HEIGHT = 24;
export const DASHBOARD_DETAIL_HEADER_CONTENT_HEIGHT = 100;

const DASHBOARD_CARD_PADDING_TOP = 8;
const DASHBOARD_CARD_ACTION_SPACING = 8;
const DASHBOARD_CARD_ACTION_HEIGHT = 32;

export const DASHBOARD_CARD_COLUMN_HEIGHT =
	DASHBOARD_CARD_PADDING_TOP +
	DASHBOARD_CARD_VALUE_BLOCK_HEIGHT +
	DASHBOARD_CARD_ACTION_SPACING +
	DASHBOARD_CARD_ACTION_HEIGHT;

export const DASHBOARD_CARD_TOOLTIP_OFFSET: [number, number] = [-50, -20];
